import { render, staticRenderFns } from "./LineItemList.vue?vue&type=template&id=08f0f42f&scoped=true&"
import script from "./LineItemList.vue?vue&type=script&lang=js&"
export * from "./LineItemList.vue?vue&type=script&lang=js&"
import style0 from "./LineItemList.vue?vue&type=style&index=0&id=08f0f42f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f0f42f",
  null
  
)

export default component.exports